/* eslint-disable no-nested-ternary */
import React, { useEffect, useRef, useState } from 'react'

import { useHistory } from 'react-router-dom'

import { FontAwesomeIcon as FontA, FontAwesomeIcon } from '@fortawesome/react-fontawesome'

import { solid } from '@fortawesome/fontawesome-svg-core/import.macro'

import { Button, Drawer, Modal, Select, Table, Timeline } from 'antd'

import { CloseOutlined, PlusOutlined } from '@ant-design/icons'
import { UploadChangeParam } from 'antd/lib/upload'
import ExclamationError from '../../../../assets/img/exclamation-error.png'
import Exclamation from '../../../../assets/img/exclamation.png'
import FormOrderSer from '../../../../Components/ordemLaboratorio'

import { Notification } from '../../../../Components/notification'

import { useLogic as useLogicOrder } from './useLogic'

import { useLogic } from '../../../../context/useLogic'

import {
  delPedLaboratorio,
  getDownloadResult,
  getPedLaboratorio,
  getPedLaboratorioStatus,
  putPedlaboratorioResultado,
  putPedlaboratorioStatus,
  reprocessarOs,
} from '../../../../services/Laboratorio'
import { Container } from './styled'

import fileBase64 from '../../../../Components/Base64Geral'
import { pagination } from '../../../../Components/Default'
import { IconAlert } from '../../../../Components/iconsAlert'
import ViewPage from '../../../../Components/ViewPage'
import { localConfig } from '../../../../Configs/localConfig'
import { CSVToJSON, fileTypeText } from '../../../../services/Afins'
import { ItensPerUserLogged } from '../../../../services/login/permissaoUsuarioLoado'
import { getSafraConsultoria } from '../../../../services/Safra'
import dayjs from 'dayjs'
import GeneratePdfButton from '../../../../Components/relatorio-component'
import { Render } from '../../../../Components/CustomUi/render'
import { destroyAlert, errorAlert, loadingAlert, successAlert } from '../../../../utils/alert'
import VisualizarPontosMap from '../../../../Components/visualizarPontosMap'
import { VisualizarMapaTabela } from './components/visualizarMapaTabela'
import Input from '../../../../Components/CustomUi/input'
import ButtonCustom from '../../../../Components/ButtonCustom'
import { faPlus, faTrash, faXmark } from '@fortawesome/free-solid-svg-icons'
import { removerAcentos } from '../../../../utils'
import { Warning } from '../../../../Components/CustomUi/warning'
import secureLocalStorage from 'react-secure-storage'

const { Option } = Select

const OrderSer: React.FC = () => {
  const { checkSafra } = useLogic()
  const { columLabOrder } = useLogicOrder()

  const refDowloadResult = useRef(null)

  const history = useHistory()

  const [isModalVisible, setIsModalVisible] = useState(false)
  const [loadingTable, setLoadingTable] = useState(false)
  const [visibleForm, setVisibleForm] = useState(false)
  const [modalTimeLine, setModalTimeLine] = useState(false)
  const [addStatus, setAddStatus] = useState(false)
  const [looadingSaveStatus, setlooadingSaveStatus] = useState(false)
  const [drawerFilePrevia, setDrawerFilePrevia] = useState(false)

  const [permissions, setPermissions] = useState<ItensPerUserLogged>()

  const [updateUpdateOrder, setUpdateUpdateOrder] = useState<number>()
  const [cloneOrder, setCloneOrder] = useState<number>()
  const [numPedido, setNumPedido] = useState<number>()

  const [selectStatus, setSelectStatus] = useState(null)
  const [colum, setColum] = useState(null)
  const [resultAnalise, setResultAnalise] = useState({
    base64: null,
    cod: null,
  })

  const [dataOrderSer, setDataOrderSer] = useState([])
  const [oldDataOS, setOldDataOS] = useState([])
  const [dataStatusOs, setDataStatusOs] = useState([])
  const [lisStatusOs, setLisStatusOs] = useState([])
  const [dataTableAnalise, setDataTableAnalise] = useState([])
  const [dataSafraConsultoria, setDataSafraConsultoria] = useState([])
  const [dadosEstatisticas, setDadosEstatisticas] = useState([])
  const [dadosResultado, setDadosResultado] = useState([])
  const [nomeCliente, setNomeCliente] = useState('')
  const codSafra = localStorage.getItem('codSafra')
  const [mapaGeral, setMapaGeral] = useState<boolean>(false)
  const [buscarTabela, setBuscarTabela] = useState<string>('')
  const [nome_propriedade, setNome_propriedade] = useState<string>('')
  const [cod_os_excluir, setCod_os_excluir] = useState<number>(0)

  const listarOrdensServico = async () => {
    setLoadingTable(true)
    const safras = await getSafraConsultoria()
    const response = await getPedLaboratorio('')
    const dados = response.data.itens

    setDataSafraConsultoria(safras.data.itens)
    setNomeCliente(dados[0]?.nome_cliente)
    gerarTabela(dados)
    gerarTabela2(dados, dados.length)
    setDataOrderSer(dados)
    gerarTabela(dados)
    setOldDataOS(dados)

    setLoadingTable(false)
  }

  function buscarOs(buscar_nome: string) {
    const palavraSemAcentos = removerAcentos(buscar_nome)
    return function (item) {
      const propriedadeNome = removerAcentos(String(item?.propriedade_nome))
      const laboratorioNome = removerAcentos(String(item?.laboratorio_nome))
      const talhaoNome = removerAcentos(String(item?.talhao_nome))
      return (
        laboratorioNome.toLowerCase().includes(palavraSemAcentos.toLowerCase()) ||
        talhaoNome.toLowerCase().includes(palavraSemAcentos.toLowerCase()) ||
        propriedadeNome.toLowerCase().includes(palavraSemAcentos.toLowerCase()) ||
        !buscar_nome
      )
    }
  }

  function gerarTabela(dados) {
    const data = dados?.map((item) => {
      return [
        { text: item?.propriedade_nome, fontSize: 7, margin: [0, 2, 0, 2], alignment: 'center' },
        { text: item?.talhao_nome, fontSize: 7, margin: [0, 2, 0, 2], alignment: 'center' },
        { text: item?.safra_nome, fontSize: 7, margin: [0, 2, 0, 2], alignment: 'center' },
        { text: item?.laboratorio_nome, fontSize: 7, margin: [0, 2, 0, 2], alignment: 'center' },
        {
          text: dayjs(item?.data).format('DD/MM/YYYY'),
          fontSize: 7,
          margin: [0, 2, 0, 2],
          alignment: 'center',
        },
      ]
    })

    const table = [
      {
        table: {
          headerRows: 1,
          widths: ['*', '*', '*', '*', '*'],
          body: [
            [
              { text: 'Propriedade', style: 'tableHeader', fontSize: 9, alignment: 'center' },
              { text: 'Talhão', style: 'tableHeader', fontSize: 9, alignment: 'center' },
              { text: 'Safra', style: 'tableHeader', fontSize: 9, alignment: 'center' },
              { text: 'Laboratório', style: 'tableHeader', fontSize: 9, alignment: 'center' },
              { text: 'Data', style: 'tableHeader', fontSize: 9, alignment: 'center' },
            ],
            ...data,
          ],
          dontBreakRows: false,
          keepWithHeaderRows: 0,
        },
        layout: {
          fillColor: function (rowIndex, node, columnIndex) {
            return rowIndex % 2 === 0 ? '#f5f5f5' : null
          },
        },
      },
    ]
    setDadosEstatisticas(table)
  }

  function gerarTabela2(dados, length) {
    const data = [[{ text: length, fontSize: 7, margin: [0, 2, 0, 2], alignment: 'center' }]]

    const table = [
      {
        table: {
          headerRows: 1,
          widths: [95], // Definindo larguras das colunas
          body: [
            [
              {
                text: 'Total os',
                style: 'tableHeader',
                fontSize: 9,
                alignment: 'center',
              },
            ],
            ...data,
          ],
          margin: [0, 50, 0, 0],
          alignment: 'center',
        },
        layout: {
          fillColor: function (rowIndex, node, columnIndex) {
            return rowIndex % 2 === 0 ? '#f5f5f5' : null
          },
        },
      },
    ]

    setDadosResultado(table)
  }

  const handleTrashOrderSer = async (data, dados) => {
    setIsModalVisible(true)
    setCod_os_excluir(data)
    setNome_propriedade(dados?.propriedade_nome)
  }

  async function excluirOs() {
    try {
      const responseDel = await delPedLaboratorio(cod_os_excluir)

      if (responseDel.status === 200) {
        successAlert('Pedido de analise excluido com sucesso!')

        listarOrdensServico()
        setIsModalVisible(false)
      }
    } catch (error) {
      if (error.response) {
        const { data } = error.response

        errorAlert(data?.error ?? 'Falha na operação')
      }
    }
  }

  const handleStatusOsColeta = async (pedido) => {
    loadingAlert({ msg: 'Carregando pedidos...', id: 'pedido' })
    loadingAlert({ msg: 'Carregando pedidos...', id: 'pedido' })
    const response = await getPedLaboratorioStatus(pedido)

    const dados = response.data.itens

    setDataStatusOs(dados.reverse())

    const ultimo = dados[dados.length - 1].status

    handleListStatus(ultimo)

    setSelectStatus(null)

    setModalTimeLine(true)

    setNumPedido(pedido)
    destroyAlert('pedido')
    destroyAlert('pedido')
  }

  const handleClickAlteraStatus = async () => {
    setlooadingSaveStatus(true)
    const status = selectStatus

    const listaStatus = lisStatusOs.find((data) => data.cod === status)

    const response = await putPedlaboratorioStatus(numPedido, listaStatus.cod)

    if (response.status === 200) {
      listarOrdensServico()

      handleStatusOsColeta(numPedido)

      successAlert(`Status da OS alterado para ${listaStatus.nome}`)
      successAlert(`Status da OS alterado para ${listaStatus.nome}`)
      setlooadingSaveStatus(false)
    } else {
      errorAlert(`ERROR ${response.status}`)
    }
  }

  const handleChangeStatus = (data) => {
    setSelectStatus(data)
  }

  const handleCloneData = (data, dados) => {
    const local = localConfig()

    if (local.codCliente === '') {
      if (dados.cod_cliente === null) {
        setCloneOrder(data)
        setVisibleForm(true)
        setUpdateUpdateOrder(0)
      } else {
        Modal.error({
          title: `Para clonar selecione o cliente correspondente: ${dados.cliente[0]?.nome}`,
        })
      }
    } else {
      setCloneOrder(data)
      setVisibleForm(true)
      setUpdateUpdateOrder(0)
    }
  }

  const handleVisibleForm = () => {
    setVisibleForm(true)
    setUpdateUpdateOrder(0)
    setCloneOrder(0)
  }

  const handleCloseForm = () => {
    setVisibleForm(false)
    setCloneOrder(0)
  }

  const handleClickUpdate = async (data, dados) => {
    const local = localConfig()
    if (local.codCliente === '') {
      if (dados.cod_cliente === null) {
        setUpdateUpdateOrder(data)
        setVisibleForm(true)
      } else {
        Modal.error({
          title: `Para editar selecione o cliente correspondente: ${dados.cliente[0]?.nome}`,
        })
      }
    } else {
      setUpdateUpdateOrder(data)
      setVisibleForm(true)
    }
  }
  const handleMapaGeral = async (data, dados) => {
    setUpdateUpdateOrder(data)
    setMapaGeral(true)
  }

  const handleOk = () => {
    setIsModalVisible(false)
  }

  const handleCancel = () => {
    setIsModalVisible(false)
  }

  // const handleTableChange = (pagination, filters) => {
  //   if (filters.status === null) {
  //     listarOrdensServico()
  //   } else {
  //     let dados = []
  //     oldDataOS?.forEach((info) => {
  //       const temp = filters?.status?.forEach((data) => {
  //         if (info.status === data) {
  //           dados = [...dados, info]
  //         }

  //         return { dados, temp }
  //       })

  //       return dados
  //     })
  //     setDataOrderSer(dados)
  //   }
  // }

  const dumpRequest = (options) => {
    const { onSuccess } = options

    setTimeout(() => {
      onSuccess('done')
    }, 500)
  }

  const handleUploadResult = async (info: UploadChangeParam, cod: number) => {
    if (info.file.status === 'done') {
      loadingAlert({ msg: 'Carregando...', id: 'upload' })
      loadingAlert({ msg: 'Carregando...', id: 'upload' })
      const csv = info.file.originFileObj

      const texCsv = await fileTypeText(csv)

      const base64 = await fileBase64(csv)

      const csvJson = await CSVToJSON(texCsv)

      setColum(csvJson.colum)
      setDataTableAnalise(csvJson.rows)

      setResultAnalise({ base64, cod })

      setDrawerFilePrevia(true)
      destroyAlert('upload')
      destroyAlert('upload')
    }
  }

  const handleDownloadResultado = async (url) => {
    if (url) {
      const response = await getDownloadResult(url)
      const link = refDowloadResult.current

      // @ts-ignore
      const newLink = URL.createObjectURL(response.data)

      link.href = newLink
      link.click()
    } else {
      errorAlert(
        'Não encontramos arquivos processados. Faça o upload de um arquivo para prosseguir',
        5000
      )
    }
  }

  const handleReprocessarOs = async (
    data,
    cod_cliente,
    nome,
    talhao,
    codCalcario,
    codCalcarioPropriede
  ) => {
    Modal.confirm({
      title:
        codCalcario !== codCalcarioPropriede
          ? `O calcário atual é diferente do processado, deseja realmente reprocessar a OS?`
          : `Deseja reprocessar a OS da ${nome} - ${talhao}?`,
      okText: 'Sim',
      cancelText: 'Não',
      icon: <IconAlert type='confirm' size={6} />,
      cancelButtonProps: {
        type: 'primary',
        danger: true,
      },
      onOk: async () => {
        try {
          loadingAlert({ msg: 'Reprocessando OS...', id: 'proce_os' })
          loadingAlert({ msg: 'Reprocessando OS...', id: 'proce_os' })
          const response = await reprocessarOs(data, cod_cliente)

          if (response.status === 200) {
            successAlert('OS reprocessada com sucesso!', 5000, 'proce_os')
            successAlert('OS reprocessada com sucesso!', 5000, 'proce_os')
            Modal.destroyAll()
          }
        } catch (error) {
          Modal.error({
            title: 'Erro',
            content: 'Ocorreu um erro ao reprocessar a OS.',
          })
          destroyAlert('proce_os')
          destroyAlert('proce_os')
        }
      },
    })
  }

  const handleEnviarFile = async () => {
    try {
      loadingAlert({ msg: 'Enviando resultado...', id: 'resultado' })
      loadingAlert({ msg: 'Enviando resultado...', id: 'resultado' })
      const response = await putPedlaboratorioResultado(resultAnalise.cod, resultAnalise.base64)

      if (response.status === 200) {
        successAlert('Resultado enviado com sucesso!', 5000, 'resultado')
        successAlert('Resultado enviado com sucesso!', 5000, 'resultado')
        listarOrdensServico()
        setDrawerFilePrevia(false)
      }
    } catch (error) {
      if (error.response) {
        const { data } = error.response
        if (!data.error[0]?.field) {
          errorAlert(data?.error ?? 'Falha na operação', 5000, 'resultado')
          errorAlert(data?.error ?? 'Falha na operação', 5000, 'resultado')
        } else {
          data.error.forEach((data) => {
            errorAlert(data?.msg?.[0] ?? 'Falha na operação', 5000, 'resultado')
            errorAlert(data?.msg?.[0] ?? 'Falha na operação', 5000, 'resultado')
          })
        }
      } else {
        errorAlert('Falha ao enviar resultado!', 5000, 'resultado')
      }
    }
  }

  const handleAtualizado = (data) => {
    setUpdateUpdateOrder(data)
    listarOrdensServico()
  }

  const handleClikAlert = async (osCod) => {
    const tipoModal = osCod.status === 8 ? Modal.error : Modal.warning

    const obs = String(osCod.observacao)

    tipoModal({
      title:
        osCod.status !== 8
          ? `Resultado com inconsistência na OS ${osCod.cod}`
          : `Erro na OS ${osCod.cod}`,
      icon: (
        <span className='anticon anticon-close-circle'>
          <img
            width='25px'
            src={osCod.status === 8 ? ExclamationError : Exclamation}
            alt='Warning'
          />
        </span>
      ),
      content: <div style={{ fontSize: '12px' }} dangerouslySetInnerHTML={{ __html: obs }} />,
      width: '800px',
      style: { top: '20px' },
      bodyStyle: { overflowY: 'scroll', maxHeight: 'calc(100vh - 200px)' },
    })
  }

  const handleListStatus = (cod) => {
    const status = [
      {
        nome: 'ABERTA',
        cod: 1,
        disable: false,
      },
      {
        nome: 'LIBERADA PARA COLETA',
        cod: 2,
        disable: false,
        hidden: process.env.NODE_ENV === 'production',
      },
      {
        nome: 'COLETADA',
        cod: 3,
        disable: false,
      },
      {
        nome: 'ENVIADO PARA ANÁLISE',
        cod: 4,
        disable: false,
      },
      {
        nome: 'EM ANÁLISE',
        cod: 5,
        disable: false,
      },

      {
        nome: 'INCONSISTÊNCIA MODERADA',
        cod: 6,
        disable: false,
        hidden: process.env.NODE_ENV === 'production',
      },
      {
        nome: 'INCONSISTÊNCIA ALTA',
        cod: 7,
        disable: false,
        hidden: process.env.NODE_ENV === 'production',
      },
      {
        nome: 'RESULTADO COM ERRO',
        cod: 8,
        disable: false,
        hidden: process.env.NODE_ENV === 'production',
      },
      {
        nome: 'ANALISADA',
        cod: 9,
        disable: false,
        // hidden: process.env.NODE_ENV === "production",
      },
    ]

    if (process.env.NODE_ENV === 'production') {
      status.forEach((data) => {
        if (data.cod <= cod || data.cod === 5) {
          data.disable = true
        }
      })
    }

    setLisStatusOs(status)
  }

  const handleAddStatus = () => {
    setAddStatus(!addStatus)
  }

  useEffect(() => {
    const idDaSafra = checkSafra('/precisao/laborder')

    if (!idDaSafra) {
      history.push('/home')
    }
    console.log('OS SAFRA', idDaSafra)
  }, [])

  useEffect(() => {
    if (codSafra !== null) {
      listarOrdensServico()
    }
  }, [codSafra])

  return (
    <Container>
      <ViewPage
        onPermission={setPermissions}
        rotina={32}
        title='OS para coleta'
        btnClick={null}
        newHide
        btnsExta={
          <div style={{ display: 'flex', gap: 10, width: '100%', alignItems: 'center' }}>
            <Input
              placeholder='Buscar por propriedade/laboratório/talhão'
              value={buscarTabela}
              onChange={setBuscarTabela}
              width={'100%'}
            />
            <ButtonCustom icon={<FontAwesomeIcon icon={faPlus} />} onClick={handleVisibleForm}>
              Novo
            </ButtonCustom>
            {secureLocalStorage.getItem('tipo-acesso') === 'conta' ? (
              <GeneratePdfButton
                dados={dadosEstatisticas}
                title={'Relatório Os'}
                disable={dataOrderSer.length <= 0}
                totais={dadosResultado}
                titleSecundario={nomeCliente}
              />
            ) : null}
          </div>
        }
        content={
          <Render condition={visibleForm}>
            <FormOrderSer
              permissions={permissions}
              visible={visibleForm}
              setOnClose={handleCloseForm}
              update={updateUpdateOrder}
              setUpdate={handleAtualizado}
              clone={cloneOrder}
            />
          </Render>
        }
      >
        <Table
          rowKey='cod'
          pagination={pagination}
          scroll={{ y: 'calc(90vh - 275px)', x: 'auto' }}
          footer={() => (
            <div
              style={{
                display: 'flex',
                width: '100%',
                justifyContent: 'right',
              }}
            >
              <b>Total geral: {dataOrderSer.length}</b>
            </div>
          )}
          // onChange={handleTableChange}
          loading={loadingTable}
          dataSource={dataOrderSer.filter(buscarOs(buscarTabela))}
          bordered
          size='small'
          columns={columLabOrder({
            dataOrderSer,
            dataSafraConsultoria,
            dumpRequest,
            handleClickUpdate,
            handleClikAlert,
            handleCloneData,
            handleDownloadResultado,
            handleStatusOsColeta,
            handleTrashOrderSer,
            handleUploadResult,
            handleReprocessarOs,
            handleMapaGeral,
            permissions,
          })}
          onRow={(record) => {
            return {
              onDoubleClick: () => {
                handleClickUpdate(record.cod, record)
              },
            }
          }}
        />

        <VisualizarMapaTabela update={updateUpdateOrder} open={mapaGeral} setOpen={setMapaGeral} />
      </ViewPage>
      <Modal
        style={{ minHeight: '100%' }}
        title='Excluir'
        closeIcon={false}
        open={isModalVisible}
        onCancel={() => setIsModalVisible(false)}
        width='30%'
        destroyOnClose
        footer={false}
      >
        <div style={{ width: '100%', display: 'flex', flexDirection: 'column', gap: 10 }}>
          <div style={{ width: '100%', display: 'flex', flexDirection: 'column', gap: 5 }}>
            <Warning type='warning'>
              Atenção: Ao deletar essa OS comprometerá a sincronização no app caso esteja ocorrendo
              a execução no campo.
            </Warning>
            <p style={{ fontWeight: '600', fontSize: 13 }}>
              Deseja realmente excluir a OS da propriedade: {nome_propriedade}?
            </p>
          </div>
          <div style={{ display: 'flex', justifyContent: 'flex-end', gap: 10 }}>
            <ButtonCustom
              type='primary'
              icon={<FontAwesomeIcon icon={faXmark} />}
              onClick={() => setIsModalVisible(false)}
            >
              Cancelar
            </ButtonCustom>
            <ButtonCustom
              type='secondary'
              icon={<FontAwesomeIcon icon={faTrash} />}
              danger
              onClick={excluirOs}
            >
              Excluir
            </ButtonCustom>
          </div>
        </div>
      </Modal>

      <Drawer
        title='Visualizar Arquivo'
        destroyOnClose
        height='89%'
        placement='bottom'
        open={drawerFilePrevia}
        closeIcon={false}
        onClose={() => setDrawerFilePrevia(false)}
        footer={
          <>
            <Button onClick={handleEnviarFile} type='primary' htmlType='submit'>
              Enviar
            </Button>
            {'   '}
            <Button
              danger
              type='primary'
              onClick={() => setDrawerFilePrevia(false)}
              style={{ marginRight: 8 }}
            >
              Fechar
            </Button>
          </>
        }
      >
        <Table
          className='head-visu'
          size='small'
          rowClassName={(record, index) => (index % 2 === 0 ? 'table-row-light' : 'table-row-dark')}
          scroll={{ x: '5000px', y: '60vh' }}
          columns={colum}
          dataSource={dataTableAnalise}
        />
      </Drawer>
      <a href='#' hidden ref={refDowloadResult}>
        a
      </a>
      <Modal
        title={`Status do Pedido ${numPedido}`}
        open={modalTimeLine}
        width={600}
        destroyOnClose
        onCancel={() => {
          setModalTimeLine(false)
          setAddStatus(false)
        }}
        style={{ top: '50px' }}
        bodyStyle={{
          paddingTop: '10px',
          maxHeight: '500px',
          flexDirection: 'column-reverse',
          overflowX: 'hidden',
          overflowY: 'auto',
        }}
        okButtonProps={{
          hidden: true,
        }}
        cancelButtonProps={{
          hidden: true,
        }}
        footer={[
          <div key='' style={{ width: '100%', display: 'flex', justifyContent: 'left', gap: 5 }}>
            <Button
              onClick={handleAddStatus}
              icon={addStatus ? <CloseOutlined /> : <PlusOutlined />}
              type='primary'
            >
              Alterar Status
            </Button>
            {'  '}
            {addStatus ? (
              <>
                <Select
                  value={selectStatus}
                  onChange={handleChangeStatus}
                  placeholder='Selecione o Status'
                  popupMatchSelectWidth
                  allowClear
                  size='middle'
                  optionFilterProp='children'
                  showSearch
                  style={{ width: '60%', textAlign: 'left' }}
                >
                  {lisStatusOs.map((data) => (
                    <Option
                      style={data.hidden ? { display: 'none' } : { display: 'block' }}
                      // disabled={data.disable}
                      key={data.cod}
                      value={data.cod}
                    >
                      {data.nome}
                    </Option>
                  ))}
                </Select>
                {'  '}
                <Button
                  disabled={selectStatus === null}
                  onClick={handleClickAlteraStatus}
                  type='primary'
                  size='middle'
                  icon={<FontA icon={solid('save')} />}
                  loading={looadingSaveStatus}
                />
              </>
            ) : (
              <>
                <b style={{ opacity: 0 }}>a</b>
              </>
            )}
          </div>,
        ]}
      >
        <Timeline mode='left'>
          {dataStatusOs.map((data, i) => {
            let color
            let arrow
            const old = i === 0 ? i : i - 1

            data.usuario_nome = String(data.usuario_nome).toLowerCase()

            if (data.status < dataStatusOs[old].status) {
              color = 'red'
              arrow = solid('arrow-alt-circle-left')
            } else {
              color = 'green'
              arrow = solid('arrow-alt-circle-right')
            }

            const dataHora = (
              <div>
                <p style={{ marginBottom: 0 }}>
                  {data.create_time.substr(0, 10).split('-').reverse().join('/') +
                    data.create_time.substr(10, 18)}
                </p>
                <p
                  className='capitalized'
                  style={{ fontSize: '10px', marginTop: 0, paddingTop: 0 }}
                >
                  {data.usuario_nome}
                </p>
              </div>
            )
            return (
              <Timeline.Item
                key=''
                dot={<FontA icon={arrow} className='timeline-Arrow-icon' />}
                color={color}
                label={dataHora}
              >
                {data.status_nome.toUpperCase()}
              </Timeline.Item>
            )
          })}
        </Timeline>
      </Modal>
    </Container>
  )
}

export default OrderSer
